// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const ReportsTabsContainer = styled.div`
  display: flex;
`;

export const InactiveTabContainer = styled.div`
  width: 200px;
  height: 60px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${COLORS.secondaryWhite};
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${COLORS.primaryGray};
`;

export const ActiveTabContainer = styled.div`
  width: 200px;
  height: 60px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${COLORS.primaryWhite};
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: ${COLORS.cornflowerBlue};
`;

export const TabContent = styled.div`
  display: flex;
  align-items: center;
`;

export const TabTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-left: 10px;
  font-family: ${FONTS.newsharp};
  margin-top: 6px;
`;

export const Icon = styled.img``;

export const ButtonContainer = styled.div`
  margin-left: 32px;
`;